/* tslint:disable */
/* eslint-disable */
export enum WorkElektroDrittkontrolleStatusEnum {
  All = 'ALL',
  Open = 'OPEN',
  Planned = 'PLANNED',
  Executed = 'EXECUTED',
  Maengelbericht = 'MAENGELBERICHT',
  MaengelberichtBehoben = 'MAENGELBERICHT_BEHOBEN',
  SinaUploaded = 'SINA_UPLOADED',
  Billed = 'BILLED'
}
